import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const selectVariations: Record<string, ThemeUIStyleObject> = {
    filter: {
        'single-value': {
            variant: 'select.single-value',
            fontWeight: (theme: CarrotTheme) => theme.fontWeights.normal,
        },
        'single-value-default': {
            variant: 'select.filter.single-value',
        },
        option: {
            variant: 'select.option',
            padding: (theme: CarrotTheme) => `9px ${theme.space.medium}`,
        },
        'option-default': {
            variant: 'select.filter.option',
            fontStretch: 'expanded',
            fontWeight: (theme: CarrotTheme) => theme.fontWeights.normal,
            backgroundColor: 'none',
            ':active': {
                backgroundColor: '#FEF9F2',
            },
        },
        'option-focused': {
            variant: 'select.filter.option',
            backgroundColor: '#FEF9F2',
        },
        'control-disabled': {
            variant: 'select.control-disabled',
            borderColor: 'transparent',
        },
        'control-default': {
            variant: 'select.control',
            borderColor: 'transparent',
        },
        'control-default-disabled': {
            variant: 'select.filter.control-disabled',
        },
        'control-error': {
            variant: 'select.control',
            borderColor: 'transparent',
        },
        'control-error-disabled': {
            borderColor: (theme: CarrotTheme) => theme.colors.errorRed,
            variant: 'select.filter.control-disabled',
        },
        'control-focused': {
            variant: 'select.control-focused',
        },
    },
};

export const select: Record<string, ThemeUIStyleObject> = {
    option: {
        padding: (theme: CarrotTheme) => `${theme.space.small} ${theme.space.medium}`,
        border: 'none',
        color: (theme: CarrotTheme) => theme.colors.black80,
        fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
        lineHeight: '24px',
        ':hover': {
            cursor: 'pointer',
        },
    },
    'option-default': {
        variant: 'select.option',
        fontStretch: 'expanded',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.normal,
        backgroundColor: 'none',
        ':active': {
            backgroundColor: '#FEF9F2',
        },
        ':hover': {
            cursor: 'pointer',
        },
    },
    'option-focused': {
        variant: 'select.option-default',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.semibold,
        backgroundColor: '#FEF9F2',
    },
    menu: {
        top: '2px',
        ':hover': {
            cursor: 'pointer',
        },
        position: 'absolute',
        minWidth: '160px',
    },
    'menu-default': {
        variant: 'select.menu',
    },
    'menu-searchable': {
        variant: 'select.menu',
        top: 'auto',
    },
    'menu-list': {
        maxHeight: '306px',
        '::-webkit-scrollbar': {
            width: '6px',
        },
        '::-webkit-scrollbar-track': {
            background: 'unset',
        },
        '::-webkit-scrollbar-thumb': {
            background: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
            borderRadius: '3px',
        },
        '::-webkit-scrollbar-thumb:hover': {
            background: (theme: CarrotTheme) => theme.colors.carrotOrange35,
        },
    },
    'menu-list-default': {
        variant: 'select.menu-list',
    },
    input: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        margin: (theme: CarrotTheme) => theme.space.none,
        padding: (theme: CarrotTheme) => theme.space.none,
    },
    'input-default': {
        variant: 'select.input',
    },
    'clear-indicator': {
        padding: (theme: CarrotTheme) => theme.space.none,
        paddingRight: (theme: CarrotTheme) => theme.space.tiny,
    },
    'clear-indicator-default': {
        variant: 'select.clear-indicator',
    },
    control: {
        boxShadow: 'none',
        color: (theme: CarrotTheme) => theme.colors.black80,
        boxSizing: 'border-box',
        minHeight: '56px',
        borderWidth: '2px',
        borderStyle: 'solid',
        backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        borderColor: (theme: CarrotTheme) => theme.colors.gray,
        cursor: 'pointer',
        ':hover': {
            border: (theme: CarrotTheme) => `2px solid ${theme.colors.carrotOrange}`,
        },
        maxWidth: '100%',
    },
    'control-disabled': {
        variant: 'select.control',
        color: (theme: CarrotTheme) => theme.colors.black40,
        backgroundColor: '#F9F9FB',
        borderColor: (theme: CarrotTheme) => theme.colors.gray,
        pointerEvents: 'auto',
        cursor: 'not-allowed',
        ':hover': {
            border: (theme: CarrotTheme) => `2px solid ${theme.colors.gray}`,
        },
    },
    'control-default': {
        variant: 'select.control',
    },
    'control-default-disabled': {
        variant: 'select.control-disabled',
    },
    'control-error': {
        variant: 'select.control',
        borderColor: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'control-error-disabled': {
        borderColor: (theme: CarrotTheme) => theme.colors.errorRed,
        variant: 'select.control-disabled',
    },
    'control-focused': {
        variant: 'select.control',
        borderColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
    },
    'control-focused-disabled': {
        borderColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        variant: 'select.control-disabled',
    },
    'single-value': {
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.semibold,
    },
    'single-value-default': {
        variant: 'select.single-value',
    },
    placeholder: {
        color: (theme: CarrotTheme) => theme.colors.black80,
    },
    'placeholder-default': {
        variant: 'select.placeholder',
    },
    'placeholder-disabled': {
        variant: 'select.placeholder',
        color: (theme: CarrotTheme) => theme.colors.black40,
    },
    ...selectVariations,
};
